import styled from '@emotion/styled';
import { ob, pop, pulse } from '../../onboardingV2.tokens';

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${({ center }) => (center ? 'center' : 'flex-start')};
    text-align: ${({ center }) => (center ? 'center' : 'left')};
    margin-bottom: 24px;
`;

export const Title = styled.h1`
    margin: 0;
    font-family: ${ob.font.heading};
    font-weight: 700;
    font-size: ${({ isDisplay }) => (isDisplay ? '28px' : '26px')};
    line-height: 1.18;
    letter-spacing: -0.015em;
    color: ${ob.color.brand};
    text-wrap: balance;

    &:focus {
        outline: none;
    }

    ${ob.bp.sm} {
        font-size: 28px;
    }
`;

export const Subtitle = styled.p`
    margin: 8px 0 0;
    font-size: 16px;
    line-height: 1.5;
    color: ${ob.color.body};
    text-wrap: pretty;
`;

export const Rings = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ ringSize }) => ringSize}px;
    height: ${({ ringSize }) => ringSize}px;
    margin-bottom: 20px;
    border-radius: 50%;
    background: ${ob.color.lime50};
    animation: ${pop} 420ms ${ob.motion.pop} both;

    ${ob.reducedMotion} {
        animation: none;
    }
`;

export const RingMiddle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 78%;
    height: 78%;
    border-radius: 50%;
    background: ${ob.color.lime200};
    animation: ${({ celebrate }) => (celebrate ? pulse : 'none')} 600ms ease-in-out 200ms 1;

    ${ob.reducedMotion} {
        animation: none;
    }
`;

export const RingInner = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72%;
    height: 72%;
    border-radius: 50%;
    background: ${({ tone }) => (tone === 'whatsapp' ? ob.color.whatsapp : ob.color.lime)};
    color: ${ob.color.brand};

    i {
        font-size: ${({ iconSize }) => iconSize}px;
        line-height: 1;
    }
`;
